import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../src/loginPage.css';
import { adminLogin } from '../api/authApi';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState({ email: '', password: '' });
    const navigate = useNavigate();
    useEffect(() => {
        const accessToken = localStorage.getItem("accessToken");
        if(accessToken){
            navigate('/dashboard')
        }
    })



    const handleSubmit = async (event) => {
        event.preventDefault();

        setError({ email: '', password: '' });

        let formIsValid = true;
        let errors = { email: '', password: '' };

        if (!email) {
            formIsValid = false;
            errors.email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            formIsValid = false;
            errors.email = 'Please enter a valid email address.';
        }

        if (!password) {
            formIsValid = false;
            errors.password = 'Password is required.';
        } else if (password.length < 6) {
            formIsValid = false;
            errors.password = 'Password must be at least 6 characters long.';
        }

        if (!formIsValid) {
            setError(errors);
            return;
        }

        try {
            console.log(email, "email")
            console.log(password, "password")

            const response = await adminLogin({ email, password })
            console.log(response, "response")
            if (response.data.status === true) {
                localStorage.setItem('accessToken', response.data.token);
                navigate('/Dashboard');
            } else {
                setError({ error, password: 'Invalid email or password.' });
            }
        } catch (error) {
            console.error('Error during login:',);
            setError({ error, password: error.response.data.message });
        }

        console.log('Login submitted:', { email, password });


        setEmail('');
        setPassword('');
    };

    return (
        <div className="login-container">
            <div>
                <h2>Login</h2>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                        />
                        {error.email && <p className="error-message">{error.email}</p>}
                    </div>

                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                        />
                        {error.password && <p className="error-message">{error.password}</p>}
                    </div>

                    <button className='login-button' type="submit">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
